
import { Container } from '@mui/material'
import HeaderSession from '../../../../../utils/headerSession';
import CadastroEstabelecimento from '../../licenciamento/cadastroEstabelecimento';
import { useState } from 'react';


export default function Index() {

    return (
        <Container >
            <HeaderSession title='RENOVAÇÃO DE ESTABELECIMENTO' />
            <CadastroEstabelecimento tipoRegisto={'Inserção'} />

            <br />
        </Container>
    )
}

